export default __webpack_public_path__ + "static/champion-htf-middleweight-webfont-5338130193c50e178bbc0d47aaf26834.ttf";